export class ApiError extends Error {
  constructor(message, status, code, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
    this.data = data;
  }
}

export async function apiFetch(path, options = {}) {
  const { json: jsonBody, headers: extraHeaders, ...rest } = options;

  const headers = { ...extraHeaders };
  let body = rest.body;

  if (jsonBody !== undefined) {
    body = JSON.stringify(jsonBody);
    headers['Content-Type'] = 'application/json';
  }

  let res;
  try {
    res = await fetch(path, {
      credentials: 'same-origin',
      ...rest,
      body,
      headers,
    });
  } catch (err) {
    throw new ApiError(err.message || 'Network error', 0, 'network_error');
  }

  const contentType = res.headers.get('Content-Type') || '';
  let data = null;
  if (contentType.includes('application/json')) {
    try {
      data = await res.json();
    } catch {
      data = null;
    }
  } else {
    try {
      data = await res.text();
    } catch {
      data = null;
    }
  }

  if (!res.ok) {
    const message = (data && typeof data === 'object' && data.error) || res.statusText || 'Request failed';
    const code = data && typeof data === 'object' ? data.code : undefined;
    throw new ApiError(message, res.status, code, data);
  }

  return data;
}

export const api = {
  get: (path, options) => apiFetch(path, { ...options, method: 'GET' }),
  post: (path, body, options) => apiFetch(path, { ...options, method: 'POST', json: body }),
  put: (path, body, options) => apiFetch(path, { ...options, method: 'PUT', json: body }),
  patch: (path, body, options) => apiFetch(path, { ...options, method: 'PATCH', json: body }),
  delete: (path, options) => apiFetch(path, { ...options, method: 'DELETE' }),
};
